(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSitePartKeyDeleteController',PublicSitePartKeyDeleteController);

    PublicSitePartKeyDeleteController.$inject = ['$uibModalInstance', 'entity', 'PublicSitePartKey'];

    function PublicSitePartKeyDeleteController($uibModalInstance, entity, PublicSitePartKey) {
        var vm = this;

        vm.publicSitePartKey = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PublicSitePartKey.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
